import { UpdateProposalProductInputSchema } from "DDD/action-objects/StageProductUpdate";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { NUMERIC_SET_VALUE_AS } from "./formUtils";

type MarkupInputPropsArgs = {
  register: UseFormRegister<UpdateProposalProductInputSchema>;
  setValue: UseFormSetValue<UpdateProposalProductInputSchema>;
};

export default function useMarkupInputProps({ register, setValue }: MarkupInputPropsArgs) {
  return register("material.markup", {
    ...NUMERIC_SET_VALUE_AS,
    onChange: () => {
      setValue("profitPercentageOverride", null, { shouldDirty: true });
      setValue("overallTotalOverride", null, { shouldDirty: true });
    },
  });
}
